export const DASHBOARD_MAIN_CONTENT_TRANSITION =
  "margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1)";

interface ResolveInitialSidebarWidthParams {
  viewportWidth: number;
  smBreakpoint: number;
  lgBreakpoint: number;
  cssSidebarWidth: string;
}

export const resolveInitialSidebarWidth = ({
  viewportWidth,
  smBreakpoint,
  lgBreakpoint,
  cssSidebarWidth,
}: ResolveInitialSidebarWidthParams): number => {
  if (viewportWidth < smBreakpoint) return 0;
  if (viewportWidth < lgBreakpoint) return 60;

  const currentCssWidth = Number.parseFloat(cssSidebarWidth);
  return Number.isFinite(currentCssWidth) ? currentCssWidth : 210;
};
